<template>
  <CommonExpansionPanel :currentPanel="0">
    <template v-slot:title-panel>
      Estadísticas
    </template>
    <v-expansion-panel-content>
      <div class="stats-container">
        <v-row class="mb-4">
          <v-col cols="12" md="7">
            <div class="d-md-flex align-center">
              <span class="text-subtitle-1 font-weight-bold mr-2 filter-title">
                Filtrar por periodo
              </span>
              <InputPeriodo @updateDate="getTodasLasEmisiones" class="filter-input" />
            </div>
          </v-col>
        </v-row>

        <div v-if="!loading">
          <v-row v-if="!noResults">
            <v-col cols="12" md="6">
              <v-row dense>
                <v-col
                  v-for="(item, index) in filteredEmisiones"
                  :key="index"
                  cols="12"
                  sm="6"
                  class="mb-4"
                >
                  <div class="coverage-card">
                    <div class="coverage-text">
                      <span class="coverage-label">{{ item.name }}</span>
                      <span class="coverage-count">{{ item.value }}</span>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-col>

            <!-- Gráfico de emisiones -->
            <v-col cols="12" md="6" class="chart-col">
              <EmisionesStatusGraphic :emisiones="todasLasEmisiones" />
            </v-col>
          </v-row>

          <div v-else>
            <v-col cols="12" md="12" class="text-center py-5">
              <span class="titulo-header">Sin resultados que mostrar</span>
            </v-col>
          </div>
        </div>

        <div v-else>
          <v-row>
            <v-col cols="12" class="d-flex align-center justify-center">
              <!-- Spinner o indicador de carga si lo deseas -->
            </v-col>
          </v-row>
        </div>
      </div>
    </v-expansion-panel-content>
  </CommonExpansionPanel>
</template>

<script>
import CommonExpansionPanel from "@/components/commonComponents/CommonExpansionPanel.vue";
import EmisionesStatusGraphic from "@/components/commonComponents/charts/EmisionesStatus.graphic.vue";
import InputPeriodo from "@/components/commonComponents/forms/InputPeriodo.vue";
import { mainAxios } from "@/mainAxios.js";
import loginData from "@/helpers/data/data-login-template.json";

export default {
  components: {
    EmisionesStatusGraphic,
    CommonExpansionPanel,
    InputPeriodo,
  },
  data() {
    return {
      todasLasEmisiones: {},
      requestConfig: {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      },
      loader: loginData,
      noResults: false,
      loading: false,
    };
  },
  computed: {
    filteredEmisiones() {
      if (!this.todasLasEmisiones["Emisiones-stats"]) return [];
      return Object.entries(this.todasLasEmisiones["Emisiones-stats"]) 
        .filter(([, value]) => value > 0)
        .map(([name, value]) => ({ name, value }));
    }
  },
  methods: {
    getTodasLasEmisiones(dates) {
      this.loading = true;
      let body = { fechas: dates };
      if (String(window.location.pathname).includes("/alianza/perfil/")) {
        body.alianza = parseInt(this.$route.params.alianza_id);
      }
      mainAxios.post("v1/emision/dashboard/data", body, this.requestConfig)
        .then(({ data }) => {
          this.todasLasEmisiones = data;
          this.loading = false;
          this.checkIfHasResults();
        });
    },
    checkIfHasResults() {
      this.noResults = this.filteredEmisiones.length === 0;
    }
  },
};
</script>

<style scoped>
.stats-container {
  padding: 30px;
}

.filter-title {
  color: #4D5358;
  font-size: 1rem;
  margin-top: -31px;
}

.filter-input {
  min-width: 50%;
}

/* Ajustamos márgenes/padding para reducir espacios */
.coverage-card {
  display: flex;
  align-items: center;
  background-color: #F5F7FA;
  border-radius: 12px;
  padding: 12px; 
  margin: 4px;   
  cursor: default;
}

.coverage-text {
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.coverage-label {
  color: #2D2F33;
  font-weight: bold;
  font-size: 0.9rem;
}

.coverage-count {
  color: #2D2F33;
  font-weight: bold;
  font-size: 0.9rem;
}

/* Quitamos overflow-x y permitimos que se reduzca sin forzar scroll */
.chart-col {
  overflow: visible;
}

/* OCULTAMOS la columna con la gráfica en pantallas < 600px (móvil) */
@media (max-width: 600px) {
  .chart-col {
    display: none !important;
  }
}
</style>
